// Optional section-local hooks for decorative scenes. No global bus/store.
export const MASCOT_SCENE_EVENT = "fireflies:mascot-scene";
export const MASCOT_ARRIVED_EVENT = "fireflies:mascot-arrived";
// Hint lifecycle: CustomEvent detail { hintOpen: boolean }. Other interruptions
// (overlays, hidden tab/page) keep the existing plain Event contract.
export const MASCOT_INTERACTION_EVENT = "fireflies:mascot-interaction";
